export enum  DailyFrequencyOccursType {
    Once = 1,
    Every  = 2,
}
